<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright1"><a id="page_iv">© 2006 by Kyle Ward</a></p><a id="page_iv">
<p class="copyright">All rights reserved.</p>
<p class="copyright">No part of this book may be reproduced, in any form, without written permission from the publisher.</p>
<p class="copyright1">Requests for permission to reproduce selections from this book should be mailed to: Permissions Department, The New Press, 38 Greene Street, New York, NY 10013.</p>
<p class="copyright">Published in the United States by The New Press, New York, 2006</p>
<p class="copyright">Distributed by W. W. Norton &amp; Company, Inc., New York</p>
<p class="copyright1"><span class="small">LIBRARY OF CONGRESS CATALOGING-IN-PUBLICATION DATA</span></p>
<p class="copyright1">Ward, Kyle Roy, 1969-</p>
<p class="copyright">History in the making: an absorbing look at how American history has changed in the telling over the last 200 years / Kyle Ward.</p>
<p class="copyright">p. cm.</p>
<p class="copyright">Includes bibliographical references and index.</p>
<p class="copyright">ISBN-13: 978-1-59558-044-3 (hc.)</p>
<p class="copyright">ISBN-10: 1-59558-044-1 (hc.)</p>
<p class="copyrighti">1. United States—History—Textbooks. 2. United States—History—Textbooks—Evaluation. 3. United States—Historiography. I. Title.</p>
<p class="copyright">E175.85.W37 2006</p>
<p class="copyrighti">973.07—dc22</p>
<p class="copyright-right">2006008886</p>
<p class="copyrighti1">The New Press was established in 1990 as a not-for-profit alternative to the large, commercial publishing houses currently dominating the book publishing industry. The New Press operates in the public interest rather than for private gain, and is committed to publishing, in innovative ways, works of educational, cultural, and community value that are often deemed insufficiently profitable.</p>
</a><p class="copyright1"><a id="page_iv"><span class="weblink"></span></a><a href="http://www.thenewpress.com" target="_blank"><span class="underline">www.thenewpress.com</span></a></p>
<p class="copyright1">Composition by <em class="italic">dix!</em></p>
<p class="copyright">This book was set in Minister Light</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?b10e5f0a